var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "correlation-matrix-wrapper w-100" }, [
    _c("span", {
      staticClass: "text-danger",
      domProps: { textContent: _vm._s(_vm.errorMessage) },
    }),
    _c("div", { staticClass: "correlation-table-wrapper w-100" }, [
      _vm.calculating
        ? _c("div", {
            staticClass: "mdi mdi-loading mdi-spin h1 vh-50 flex-center",
          })
        : _c("table", { staticClass: "table correlation mb-0" }, [
            _c("thead", [
              _c(
                "tr",
                [
                  _c("th", { staticClass: "legend pt-0" }, [
                    _c(
                      "div",
                      { staticClass: "chart-nav mobile mb-2 d-md-none" },
                      [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.selectedPeriod,
                                expression: "selectedPeriod",
                              },
                            ],
                            attrs: { id: "correction-mobile-chart-nav" },
                            on: {
                              change: function ($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.selectedPeriod = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              },
                            },
                          },
                          _vm._l(_vm.periods, function (period) {
                            return _c("option", {
                              attrs: { disabled: period.disabled },
                              domProps: {
                                value: period.value,
                                textContent: _vm._s(period.label),
                              },
                            })
                          }),
                          0
                        ),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "chart-nav desktop mb-2 d-none d-md-block",
                      },
                      [
                        _c("ci-simple-tabs", {
                          staticClass: "chart",
                          attrs: {
                            options: _vm.periods,
                            scrollable: true,
                            tracking: false,
                          },
                          model: {
                            value: _vm.selectedPeriod,
                            callback: function ($$v) {
                              _vm.selectedPeriod = $$v
                            },
                            expression: "selectedPeriod",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "table",
                      { staticClass: "table correlation-example text-xs mb-0" },
                      [
                        _c("tr", [
                          _c("th", { staticClass: "border-top-0" }),
                          _c("th", { staticClass: "border-top-0 py-1" }, [
                            _c("span", {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t(
                                    "ui.shared.global.metrics.correlation.positive"
                                  )
                                ),
                              },
                            }),
                            _c("div", {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover",
                                  value: _vm.tooltips.positive,
                                  expression: "tooltips.positive",
                                  modifiers: { hover: true },
                                },
                              ],
                              staticClass:
                                "mdi mdi-information mdi-18px ml-2 text-muted",
                            }),
                          ]),
                          _c("th", { staticClass: "border-top-0 py-1" }, [
                            _c("span", {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t(
                                    "ui.shared.global.metrics.correlation.negative"
                                  )
                                ),
                              },
                            }),
                            _c("div", {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover",
                                  value: _vm.tooltips.negative,
                                  expression: "tooltips.negative",
                                  modifiers: { hover: true },
                                },
                              ],
                              staticClass:
                                "mdi mdi-information mdi-18px ml-2 text-muted",
                            }),
                          ]),
                        ]),
                        _c("tr", [
                          _c("th", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t(
                                  "ui.shared.global.metrics.correlation.high"
                                )
                              ),
                            },
                          }),
                          _c(
                            "td",
                            { staticClass: "font-weight-normal red light" },
                            [_vm._v("0,70 - 1,00")]
                          ),
                          _c(
                            "td",
                            { staticClass: "font-weight-normal red dark" },
                            [_vm._v("-0,70 - (-1,00)")]
                          ),
                        ]),
                        _c("tr", [
                          _c("th", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t(
                                  "ui.shared.global.metrics.correlation.medium"
                                )
                              ),
                            },
                          }),
                          _c(
                            "td",
                            { staticClass: "font-weight-normal gray light" },
                            [_vm._v("0,5 - 0,69")]
                          ),
                          _c(
                            "td",
                            { staticClass: "font-weight-normal gray dark" },
                            [_vm._v("-0,5 - (-0,69)")]
                          ),
                        ]),
                        _c("tr", [
                          _c("th", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t(
                                  "ui.shared.global.metrics.correlation.low"
                                )
                              ),
                            },
                          }),
                          _c(
                            "td",
                            { staticClass: "font-weight-normal green light" },
                            [_vm._v("0 - 0,49")]
                          ),
                          _c(
                            "td",
                            { staticClass: "font-weight-normal green dark" },
                            [_vm._v("0 - (-0,49)")]
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _vm._l(_vm.correlationData, function (data, index) {
                    return _c(
                      "th",
                      {
                        key: `correlation_${data.identifier}`,
                        staticClass: "text-xs",
                        class: { hovering: _vm.hovering.x === index },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "flex-center h-100 w-100",
                            style: _vm.nameStyleColumn(data, index),
                          },
                          [
                            _c("div", {
                              directives: [
                                {
                                  name: "line-clamp",
                                  rawName: "v-line-clamp",
                                  value: 2,
                                  expression: "2",
                                },
                              ],
                              staticClass: "vertical px-2",
                              domProps: { textContent: _vm._s(data.name) },
                            }),
                          ]
                        ),
                      ]
                    )
                  }),
                ],
                2
              ),
            ]),
            _c(
              "tbody",
              {
                class: {
                  hovering: _vm.hovering.x !== null && _vm.hovering.y !== null,
                },
              },
              _vm._l(_vm.correlationData, function (rowData, index) {
                return _c(
                  "tr",
                  {
                    key: `correlation_${rowData.identifier}_header`,
                    staticClass: "text-xs",
                  },
                  [
                    _c(
                      "th",
                      { class: { hovering: _vm.hovering.y === index } },
                      [
                        _c("span", {
                          style: _vm.nameStyleRow(rowData, index),
                          domProps: { textContent: _vm._s(rowData.name) },
                        }),
                      ]
                    ),
                    _vm._l(rowData.correlations, function (correlation, index) {
                      return _c(
                        "td",
                        {
                          key: `correlation_${rowData.identifier}_${index}`,
                          staticClass: "p-0",
                          class: correlation.color,
                        },
                        [
                          _c("div", {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover.top.noninteractive",
                                value: correlation.tooltip,
                                expression: "correlation.tooltip",
                                modifiers: {
                                  hover: true,
                                  top: true,
                                  noninteractive: true,
                                },
                              },
                            ],
                            staticClass: "inner p-1 flex-center",
                            domProps: {
                              textContent: _vm._s(
                                correlation.value === null
                                  ? ""
                                  : correlation.value
                              ),
                            },
                            on: {
                              mouseover: function ($event) {
                                return _vm.handleCorrelationMouseover(
                                  correlation
                                )
                              },
                              mouseleave: _vm.handleCorrelationMouseleave,
                            },
                          }),
                        ]
                      )
                    }),
                  ],
                  2
                )
              }),
              0
            ),
          ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }